import i18n from 'emoji-picker-element/i18n/en.js';
import datasource from 'emoji-picker-element-data/en/emojibase/data.json';
import { createPopper } from '@popperjs/core';
import { Picker } from 'emoji-picker-element';

function isDarkTheme() {
	return document.documentElement.getAttribute("data-theme") === 'dark';
}

async function onEmojiPickerToggle(event)
{
	const element = event.detail.element;
	const button = element.querySelector('.emoji-picker-button');
	const popup = element.querySelector('.emoji-picker-popup');
	const existingPicker = popup.querySelector('emoji-picker');

	if(existingPicker != null) {
		existingPicker.classList.remove("dark", "light");
		existingPicker.classList.add(isDarkTheme() ? "dark" : "light");
		return;
	}

	const customEmoji = await fetch('/api/public/emoji/custom');
	const customEmojiData = await customEmoji.json();

	const picker = new Picker({
		i18n: i18n,
		locale: 'en',
		dataSource: '/api/public/emoji',
		customEmoji: customEmojiData,
	})

	picker.classList.add(isDarkTheme() ? "dark" : "light");
	popup.appendChild(picker);

	createPopper(button, popup, {
		placement: popup.dataset.popupPlacement,
		modifiers: [
			{
				name: 'offset',
				options: {
					offset: [
						parseInt(popup.dataset.popupOffsetX),
						parseInt(popup.dataset.popupOffsetY)
					],
				},
			},
		]
	});

}

document.addEventListener("emoji-picker-toggle", onEmojiPickerToggle);
